import { Injectable, Signal, inject, computed } from '@angular/core';
import { SeoPatternState, SeoRedirectState } from './interfaces';
import { SemSeoStore } from './sem-seo.store';
import { RouteUrls } from '@lentau/ui-kit/core/enums/route.enum';
import { SemUsePatternResponseInfo } from 'angular-api-gateway/v1/model/semUsePatternResponseInfo';

@Injectable({ providedIn: 'root' })
export class SemSeoFacade {
  private semSeoStore: SemSeoStore = inject(SemSeoStore);

  public h1: Signal<string> = computed(() => this.semSeoStore.pattern()?.data?.info?.h1);

  public text: Signal<string> = computed(() => this.semSeoStore.pattern()?.data?.info?.text);

  public description: Signal<string> = computed(() => this.semSeoStore.pattern()?.data?.info?.description);

  public url: Signal<string> = computed(() => this.semSeoStore.pattern()?.data?.url_path);

  public redirect: Signal<SeoRedirectState> = this.semSeoStore.redirect;
  public pattern: Signal<SeoPatternState> = this.semSeoStore.pattern;

  public catalogH1: Signal<string> = computed((): string => {
    const pattern: SeoPatternState = this.semSeoStore.pattern();

    if (!!pattern?.data?.url_path && pattern?.data?.url_path.includes(RouteUrls.Catalog) && pattern.data?.info) {
      const info: SemUsePatternResponseInfo = pattern.data.info;
      return info.h1;
    }

    return '';
  });

  public getRedirectInfo(url: string): void {
    this.semSeoStore.getRedirectInfo(url);
  }

  public clearState(): void {
    this.semSeoStore.clearState();
  }
}
